import {
  SET_FLOW_METHOD_RESPONSE,
  CACHE_FLOW_METHOD,
  CLEAR_FLOW_METHOD_CACHE,
  CACHE_USER_FIELD
} from '../types';

const initialState = {
  flowMethodResponse: {},
  flowMethodCache: {},
  userFieldCache: {},
};

const flowMethodResponse = (state = initialState, action) => {
  switch (action.type) {
    case SET_FLOW_METHOD_RESPONSE:
      return {
        ...state,
        flowMethodResponse: action.payload,
      };

    case CACHE_FLOW_METHOD:
      return {
        ...state,
        flowMethodCache: {
          ...state.flowMethodCache,
          [action.payload.id]: action.payload.data,
        },
      };

    case CLEAR_FLOW_METHOD_CACHE:
      return {
        ...state,
        flowMethodCache: {},
      };

    case CACHE_USER_FIELD:
      return {
        ...state,
        userFieldCache: {
          ...state.userFieldCache,
          [action.payload.id]: action.payload.data,
        },
      };

    default:
      return state;
  }
};

export default flowMethodResponse;
